import React from "react";

// Renders a pipeline's stages as a chip row: Import → Transform → Allocation → …
//
// Driven entirely by the `stages` array the backend returns from
// GET /api/v1/pipelines/{id}. It deliberately owns no knowledge of which stages exist:
// this component replaced two hardcoded four-item literals that could not render the
// dynamically-appended Rollover stage, and hardcoding the list again -- here or in a
// job-type-to-index map at a call site -- would reintroduce that bug.
//
// Props:
//   stages      Array<{stage:number, name:string}>
//   activeStage number|null -- the stage to highlight, or null for none
const PipelineStageStrip = ({ stages, activeStage }) => {
  if (!Array.isArray(stages) || stages.length === 0) return null;

  const ordered = [...stages].sort((a, b) => a.stage - b.stage);

  return (
    <div className="flex items-center gap-1.5 text-xs flex-wrap">
      {ordered.map((s, i) => {
        // Compare against null/undefined explicitly: stage 0 (Import) is a valid
        // active stage and would be swallowed by a truthiness check.
        const isActive = activeStage != null && s.stage === activeStage;
        return (
          <React.Fragment key={s.stage}>
            {i > 0 && <span className="text-text-3">→</span>}
            <span
              data-testid="pipeline-stage-chip"
              data-active={isActive ? "true" : "false"}
              className={`px-2 py-1 rounded font-medium ${
                isActive ? "bg-primary text-white" : "bg-surface-2 text-text-2"
              }`}
            >
              {s.name}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PipelineStageStrip;
